import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalidadeGarantiaService } from "../modalidade-garantia.service";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { OperacaoCreditoLivreDominioModalidade } from 'src/app/model/operacao-credito-livre-dominio-modalidade';
import { OperacaoCreditoLivreDominioIndexador } from 'src/app/model/operacao-credito-livre-dominio-indexador';
import { TaxaAtualizacaoGarantiaDTO } from 'src/app/model/dominio-operacao.model';
import { MensagemService } from '../../mensagem.service';
import { ModalidadeOperacionalCreditoLivre } from 'src/app/model/modalidade-operacional-credito-livre-model';

@Component({
    selector: 'app-modal-taxa-atualizacao-garantia',
    templateUrl: './modal-taxa-atualizacao-garantia.component.html',
    styleUrls: ['./modal-taxa-atualizacao-garantia.component.scss'],
    standalone: false
})

export class ModalTaxaAtualizacaoGarantiaComponent implements OnInit {
  public percentual: number;
  public formulario: FormGroup;
  public mensagemAviso: string = "";
  public hoje = new Date();
  @Input() modalidadesOpe: ModalidadeOperacionalCreditoLivre[] = [];
  @Input() indexadores: OperacaoCreditoLivreDominioIndexador[] = [];

  constructor(
    public activeModal: NgbActiveModal, 
    private formBuilder: FormBuilder,
    private modalidadeService: ModalidadeGarantiaService,
    private mensagemService: MensagemService,    
  ) {
    this.formulario = this.formBuilder.group({
      dataInicioValidade: [null, [Validators.required]],
      dataFinalValidade: [null],
      ideModalidade: [null, [Validators.required]],
      ideIndexador: [null, [Validators.required]],
      taxaGarantia: [null, [Validators.required, Validators.min(0)]],
    });
  }

  ngOnInit(): void {
    this.hoje.setDate(this.hoje.getDate() + 1);
  }

  salvar() {
    const dados = this.formulario.value;
    this.modalidadeService.salvarTaxaAtualizacaoGarantia(dados).subscribe(() => {
      this.fecharAposSalvar(dados);
      this.mensagemService.adicionarMensagemSucesso("Taxa de Atualização de Garantia salva com sucesso.");
    }, (error) => {
      this.mensagemService.adicionarMensagemErro('Erro ao tentar salvar Taxa de Atualização de Garantia.');
    })
  }

  fechar() {
    this.activeModal.close({botao: 'fechar', valor: null});
  }

  fecharAposSalvar(dados: any) {
    this.activeModal.close({botao: 'salvar', valor: dados});
  }

}
